import React from "react";
import GreyCard from '../../components/GreyCard/GreyCard'
import MyCard from "../../components/MyCard/MyCard";
import StartStep from "../../components/StartStep/StartStep";
import {Accordion, Button, Col, ProgressBar, Stack, Tab, Tabs} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import WelcomeStart from "../../components/WelcomeStart/WelcomeStart";


const AboutUs = () => {
    return (
        <div>
            <WelcomeStart />

        </div>
    )
}

export default AboutUs;